import { FC, useState, ChangeEvent } from 'react';
import {
  StyledDialog,
  SubtitleSecondary,
  ReasonTextArea,
  ButtonContainer,
  RejectButton,
  CancelButton,
} from 'src/components/DialogBox/RejectDialogV2/RejectDialogV2.styles';
import ConfirmHeaderV2 from 'src/components/Headers/ConfirmationHeaderV2';
import { CloseIcon } from 'src/components/DialogBox/DialogBox.styles';

interface RejectDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: (reason: string) => void;
  title?: string;
  subtitle?: string;
  subtitleSecondary?: string;
  placeholder?: string;
  confirmText?: string;
  loading?: boolean;
}

const RejectDialog: FC<RejectDialogProps> = ({
  open,
  onClose,
  onConfirm,
  title = 'Reject',
  subtitle = 'Are you sure you want to reject this item?',
  subtitleSecondary = 'Once rejected, this action cannot be reversed.',
  placeholder = '',
  confirmText = 'Reject',
  loading = false,
}) => {
  const [reason, setReason] = useState('');
  const [touched, setTouched] = useState(false);

  const handleReasonChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
    setReason(e.target.value);
    setTouched(true);
  };
  const isReasonEmpty = reason.trim().length === 0;

  const handleConfirm = () => {
    if (reason.trim()) {
      onConfirm(reason);
    } else {
      setTouched(true);
    }
  };

  const handleClose = () => {
    setReason('');
    setTouched(false);
    onClose();
  };

  return (
    <StyledDialog open={open} onClose={handleClose}>
      <CloseIcon
        component="i"
        className="bx bx-x-circle"
        onClick={handleClose}
      />
      <ConfirmHeaderV2
        iconColor="var(--error)"
        title={title}
        subtitle={subtitle}
      />
      {subtitleSecondary && (
        <SubtitleSecondary>{subtitleSecondary}</SubtitleSecondary>
      )}
      <ReasonTextArea
        placeholder={placeholder}
        value={reason}
        onChange={handleReasonChange}
        style={{
          borderColor: touched && isReasonEmpty ? 'var(--error)' : undefined,
        }}
      />
      <ButtonContainer>
        <RejectButton
          onClick={handleConfirm}
          disabled={isReasonEmpty || loading}
        >
          {loading ? 'Rejecting...' : confirmText}
        </RejectButton>
        <CancelButton onClick={handleClose}>Cancel</CancelButton>
      </ButtonContainer>
    </StyledDialog>
  );
};

export default RejectDialog;
